{
  "en": {
    "actions": {
      "admin": {
        "dashboard": {
          "reloadModels": "Reload Models",
          "reloadScData": "Reload SC Data",
          "reloadPaints": "Reload Paints",
          "reloadModules": "Reload Modules",
          "reloadLoaners": "Reload Loaners"
        },
        "supporterContributions": {
          "syncFromPatreon": "Sync from Patreon"
        }
      },
      "showReleased": "Show old Releases",
      "hideReleased": "Hide old Releases",
      "upgrade": "Update available!",
      "backToHome": "Plot new course",
      "disableGrouping": "Disable Grouping",
      "enableGrouping": "Enable Grouping",
      "groupedByModel": "Grouped by Model",
      "ungrouped": "Ungrouped",
      "destroyAccount": "Destroy Account",
      "saveScreenshot": "Save as PNG",
      "resolve": "Resolve",
      "verify": "Verify",
      "clearHistory": "Clear History",
      "sortBy": "Sort by",
      "back": "Back",
      "open": "Open",
      "copy": "Copy",
      "more": "More...",
      "showMore": "Show more",
      "export": "Export",
      "exportHangarLink": "Export for hangar.link",
      "import": "Import",
      "here": "here",
      "backToList": "Back to List",
      "backToTop": "Back to Top",
      "cancel": "Cancel",
      "ok": "Ok",
      "reset": "Reset",
      "reload": "Reload",
      "confirm": "Confirm",
      "moreInfo": "More information",
      "showDetailPage": "Detail Page",
      "showDetails": "Show Details",
      "hideDetails": "Hide Details",
      "showGuide": "Show Guide",
      "hideGuide": "Hide Guide",
      "showFleetchart": "Fleetchart",
      "hideFleetchart": "Default view",
      "fleetchartApp": {
        "useExtendedState": "Show ships in extended state",
        "useRetractedState": "Show ships in retracted state"
      },
      "showLabels": "Show Labels",
      "hideLabels": "Hide Labels",
      "resetZoom": "Reset Zoom",
      "supportUs": "Support FleetYards.net",
      "supportHint": {
        "cta": "Support FleetYards",
        "later": "Maybe later"
      },
      "login": "Login",
      "signUp": "Sign Up",
      "confirmAccess": "Confirm password",
      "sendConfirmAccessEmail": "Send confirmation email",
      "reset-password": "Forgot password?",
      "edit": "Edit",
      "clear": "Clear",
      "done": "Done",
      "share": "Share",
      "change": "Change",
      "upload": "Upload",
      "save": "Save",
      "enable": "Enable",
      "disable": "Disable",
      "manage": "Manage",
      "enableGlobally": "Enable Globally",
      "disableGlobally": "Disable Globally",
      "addActor": "Add Actor",
      "addGroup": "Add Group",
      "remove": "Remove",
      "delete": "Delete",
      "deleteSelected": "Delete Selected",
      "enableSelected": "Enable Selected",
      "disableSelected": "Disable Selected",
      "close": "Close",
      "filter": "Filter",
      "showStatusColor": "Show Status as Color",
      "hideStatusColor": "Hide Status as Color",
      "addToHangar": "Add to Hangar",
      "resetFilter": "Reset Filter",
      "resetPrices": "Reset Prices",
      "requestPassword": "Request Password email",
      "changePassword": "Change Password",
      "updatePassword": "Update Password",
      "copyBackupCodes": "Copy Backup Codes",
      "regenerate": "Regenerate",
      "add": "Add",
      "create": "Create",
      "addToWishlist": "Add to Wishlist",
      "addAnother": "Add another",
      "addVehicle": "Add Ships",
      "addModule": "Add another Module",
      "addUpgrade": "Add another Upgrade",
      "showTableView": "Display as List",
      "showGridView": "Display as Grid",
      "linkExisting": "Link Existing",
      "loadMore": "Load more",
      "unlink": "Unlink",
      "syncRsiHangar": "Sync RSI Hangar",
      "oauthApplications": {
        "create": "New Application",
        "regenerateSecret": "Regenerate Secret"
      },
      "oauthAuthorize": {
        "authorize": "Authorize",
        "deny": "Deny"
      },
      "verifyWithCitizenId": "Verify with Citizen iD",
      "oauth": {
        "signInWith": "Sign in with",
        "google": "Google",
        "discord": "Discord",
        "bluesky": "BlueSky",
        "github": "GitHub",
        "twitch": "Twitch",
        "citizenid": "Citizen iD",
        "connected": {
          "google": "Connected to Google",
          "discord": "Connected to Discord",
          "bluesky": "Connected to BlueSky",
          "github": "Connected to GitHub",
          "twitch": "Connected to Twitch",
          "citizenid": "Connected to Citizen iD"
        },
        "disconnect": {
          "google": "Disconnect Google",
          "discord": "Disconnect Discord",
          "bluesky": "Disconnect BlueSky",
          "github": "Disconnect GitHub",
          "twitch": "Disconnect Twitch",
          "citizenid": "Disconnect Citizen iD"
        }
      },
      "compare": {
        "ships": "Compare"
      },
      "hangar": {
        "editGroups": "Add or remove Groups",
        "editName": "Name your Ship",
        "manageLoadouts": "Manage Loadouts",
        "backToHangar": "Back to Hangar",
        "useName": "Use Name",
        "destroyAll": "Remove all Ships",
        "showOnPublicHangar": "Make Public",
        "hideFromPublicHangar": "Hide from Public",
        "editGroupsSelected": "Add/Remove from Groups",
        "resetIngame": {
          "openModal": "Reset Ingame Ships after Wipe",
          "moveToWishlist": "Move to Wishlist",
          "removeAll": "Remove all"
        }
      },
      "syncExtension": {
        "cancel": "Cancel",
        "start": "Start Sync",
        "retry": "Retry Sync",
        "close": "Close",
        "refresh": "Refresh Page"
      },
      "empty": {
        "hangarGuide": "Need Help?",
        "reset": "Clear Filters"
      },
      "destroyFleet": "Destroy Fleet",
      "restore": "Restore",
      "fleet": {
        "join": "Join %{fleet}!",
        "leave": "Leave %{fleet}",
        "createInviteUrl": "Create Invite Urls",
        "inviteMember": "Invite new Member",
        "manageInvites": "Invites",
        "worldmap": "Worldmap",
        "starmap": "Starmap",
        "membersList": "Members",
        "acceptInvite": "Accept Invitation",
        "declineInvite": "Decline Invitation",
        "acceptRequest": "accept Request",
        "declineRequest": "Decline Request",
        "showOwners": "More",
        "members": {
          "invite": "Invite",
          "promote": "Promote",
          "demote": "Demote",
          "accept": "Accept",
          "decline": "Decline",
          "remove": "Remove",
          "editRole": "Edit Role"
        },
        "inviteUrls": {
          "create": "Create new Invite Url"
        }
      },
      "fleets": {
        "logistics": {
          "viewInventories": "View Inventories",
          "viewRequests": "View Requests",
          "newRequest": "New Request",
          "createRequest": "Create Request",
          "createInventory": "New Inventory",
          "submit": "Submit",
          "approve": "Approve",
          "reject": "Reject",
          "startWork": "Start Work",
          "fulfill": "Fulfill",
          "cancel": "Cancel",
          "addComment": "Add Comment",
          "deposit": "Deposit",
          "withdraw": "Withdraw",
          "createItem": "Add Item",
          "importCsv": "Import CSV",
          "downloadTemplate": "Download Template"
        }
      },
      "model": {
        "gallery": "Gallery",
        "onSale": "On Sale: %{price}",
        "store": "RSI Page"
      },
      "models": {
        "sync": "Sync from RSI",
        "syncMatrix": "Sync Matrix",
        "syncScData": "Sync SC Data",
        "exchangeStoreImage": "Use RSI Image",
        "images": "Images",
        "openTableConfiguration": "Open Table Configuration"
      },
      "users": {
        "loginAs": "Login as User",
        "resendConfirmation": "Resend Confirmation",
        "sendPasswordReset": "Send Password Reset"
      },
      "unselect": "Unselect all Selected",
      "openPriceModal": "Submit Price",
      "twoFactor": {
        "enable": "Enable Two-factor",
        "disable": "Disable Two-factor",
        "generateBackupCodes": "Generate Backup Codes"
      },
      "holoViewer": {
        "autoRotate": {
          "enable": "Enable auto rotate",
          "disable": "Disable auto rotate"
        },
        "zoom": {
          "enable": "Enable zoom",
          "disable": "Disable zoom"
        },
        "color": {
          "enable": "Enable colors",
          "disable": "Disable colors"
        }
      },
      "roadmap": {
        "showRemoved": "Show Removed",
        "hideRemoved": "Hide Removed"
      }
    }
  }
}
